import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { DEPLOYMENTS_ANNOTATION } from '../../components/deployments/shared';
import { getStoredFunMode, translate } from '../i18n';

/**
 * Per-service DORA tab. Shown only for components carrying deployment data
 * (same filter idiom as DeploymentsEntityContent). Tab order is pinned by
 * listing entity-content:dora/dora in app.extensions in app-config.yaml.
 */
export const doraEntityContent = EntityContentBlueprint.make({
  name: 'dora',
  params: {
    path: '/dora',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('dora.entityContent.title', getStoredFunMode()),
    filter: {
      kind: 'component',
      [`metadata.annotations.${DEPLOYMENTS_ANNOTATION}`]: { $exists: true },
    },
    loader: () =>
      import('./DoraServiceCard').then(m => (
        <PageShareTitle title="DORA metrics">
          <Content>
            <m.DoraServiceCard />
          </Content>
        </PageShareTitle>
      )),
  },
});
